import {configureStore,combineReducers} from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import CartReducer from "./Slices/CartSlice";
import AuthSlice from "./Slices/AuthSlice";


const persistConfig = {
	key: "root",
	storage,
};

const rootReducer = combineReducers({
    CartSlice: CartReducer,
    Auth : AuthSlice,
	
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
	reducer: persistedReducer,
	// middleware: [...getDefaultMiddleware(), thunkMiddleware],
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({ serializableCheck: false })
});

const persistor = persistStore(store);

export { store, persistor };
